import { FormColor } from './colour'
import { FormCurrency } from './currency'
import { FormDate } from './date'
import { FormText, FormNumber, FormImage } from './input'
import { FormToggle } from './toggle'
import {
  FormLists,
  FormBrandList,
  FormChampionshipList,
  FormWrestlerList,
  FormTeams,
  FormSegmentList,
  FormShowList
} from './lists'

import {
  FormFrequencySelect,
  FormSelectBrand,
  FormSelectChampionship,
  FormSelectWrestler,
  FormSelectDirector,
  FormWeekSelect,
  FormSelectVenue,
  FormSelectDayOfWeek,
  FormSelectSegmentTypes,
  FormMultipleSelectBrands,
  FormMonthSelect,
  FormSelectShow,
  FormMultipleSelectChampionships,
  FormMultipleSelectSegments,
  FormSelectGender,
  FormSelectAlignment
} from './multi-select'
import { FormMarkdown } from './markdown'

const exports = {
  FormColor,
  FormImage,
  FormToggle,

  FormLists,
  FormFrequencySelect,
  FormBrandList,
  FormSegmentList,
  FormChampionshipList,
  FormWrestlerList,
  FormShowList,
  FormTeams,
  FormSelectAlignment,

  FormSelectShow,
  FormSelectVenue,
  FormDate,
  FormMonthSelect,
  FormWeekSelect,
  FormText,
  FormNumber,
  FormCurrency,

  FormSelectDayOfWeek,
  FormSelectSegmentTypes,
  FormSelectChampionship,
  FormSelectWrestler,
  FormSelectDirector,
  FormSelectBrand,
  FormSelectGender,

  FormMultipleSelectBrands,
  FormMultipleSelectChampionships,
  FormMultipleSelectSegments,

  FormMarkdown
}

const getComponent = key => exports[key]

export {
  getComponent,
  FormColor,
  FormToggle,
  FormImage,
  FormLists,
  FormTeams,
  FormBrandList,
  FormChampionshipList,
  FormFrequencySelect,
  FormMonthSelect,
  FormSegmentList,
  FormWrestlerList,
  FormSelectAlignment,
  FormWeekSelect,
  FormShowList,
  FormDate,
  FormText,
  FormNumber,
  FormSelectShow,
  FormCurrency,
  FormSelectBrand,
  FormSelectWrestler,
  FormSelectDirector,
  FormSelectDayOfWeek,
  FormSelectChampionship,
  FormSelectSegmentTypes,
  FormMultipleSelectChampionships,
  FormMultipleSelectBrands,
  FormMultipleSelectSegments,
  FormMarkdown
}
